import { DOCUMENT } from "@angular/common";
import { Inject, inject, Injectable } from "@angular/core";

import { timer } from "rxjs";

import { GlobalService } from "@shared/services";
import { CustomWindow } from "@shared/models";

declare let window: CustomWindow;

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  globalService = inject(GlobalService);

  constructor(@Inject(DOCUMENT) private document: Document) {}

  themes = [
    { id: "mdc-light-indigo", label: "MDC Light Indigo" },
    { id: "mdc-dark-indigo", label: "MDC Dark Indigo" },
  ];

  applyTheme(theme: string) {
    const themeId = theme === "light" ? "mdc-light-indigo" : "mdc-dark-indigo";
    let themeLink = this.document.getElementById("app-theme") as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = themeId + ".css";
    }
    localStorage.setItem("theme", theme);
    this.globalService.theme.set(theme);
  }

  init(): void {
    timer(0, 1000).subscribe(() => {
      const theme = localStorage.getItem("theme");
      if (window.userTheme) {
        this.globalService.isApaApp.set(true);
        if (window.userTheme === "light") {
          if (this.globalService.theme() === "dark") {
            this.applyTheme("light");
            this.globalService.theme.set("light");
          }
        } else {
          if (this.globalService.theme() === "light") {
            this.applyTheme("dark");
            this.globalService.theme.set("dark");
          }
        }
      } else {
        if (theme) {
          if (this.globalService.theme() !== theme) {
            this.applyTheme(theme);
            this.globalService.theme.set(theme);
          }
        } else {
          this.applyTheme("light");
          localStorage.setItem("theme", "light");
          this.globalService.theme.set("light");
        }
      }
    });
  }
}
